/*
 Initial state and properties
 */
 export const initialState = {
    mode:"POST",
    supervisorIdSelected:0,
    defaultDataSupervisor:{}
 }
 /*
  Action types
  */
 export const SET_MODE = 'SET_MODE'
 export const SET_SUPERVISOR_ID = 'SET_SUPERVISOR_ID'
 export const SET_DEFAULT_DATA = 'SET_DEFAULT_DATA'
 /*
  Arrow function for change state
  */
 export const setMode = (payload) => ({
   type: SET_MODE,
   payload,
 });
 export const setSupervisorId = (payload) => ({
  type: SET_SUPERVISOR_ID,
  payload,
})
export const setDefaultDataSupervisor = (payload) => ({
  type: SET_DEFAULT_DATA,
  payload,
})
 /*
  Reducer to describe how the state changed
  */
 export default function Reducer(state = initialState, { type, payload }) {
   switch (type) {
     case SET_MODE:
       return {
         ...state,
         mode: payload,
       }
       case SET_SUPERVISOR_ID:
        return {
          ...state,
          supervisorIdSelected: payload,
        }
        case SET_DEFAULT_DATA:
          return {
            ...state,
            defaultDataSupervisor: payload,
          }
     default:
       return state
   }
 }
 